export const PATHS = {
  home: "/",
  about: "/hakkimizda",
  group: "/hakkimizda/securitas-grup",
  values: "/hakkimizda/degerlerimiz",
  quality: "/hakkimizda/securitas-kalite",
  services: "/hizmetlerimiz",
  fire: "/hizmetlerimiz/itfaiye-hizmeti",
  watch: "/hizmetlerimiz/gozlem-hizmeti",
  multiRole: "/hizmetlerimiz/multi-rol-guvenlik-gorevlisi",
  trainings: "/egitimlerimiz",
  trainingAdvanced: "/egitimlerimiz/ileri-seviye-atesli-temel-itfaiye-egitimi",
  trainingTheory: "/egitimlerimiz/teorik-ve-uygulamali-yangin-egitimi",
  trainingFireBehaviour: "/egitimlerimiz/yanginda-davranis-sekilleri",
  blog: "/blog",
} as const;

export const EXTERNAL = {
  contact: "https://www.securitas.com.tr/iletisim/bize-ulasin/",
  securitas: "https://www.securitas.com.tr/",
  securitasGroup: "https://www.securitas.com.tr/hakkimizda/securitas-grup/",
  introVideo: "https://www.youtube.com/watch?v=spDkX8-U1S0",
  linkedin: "https://www.linkedin.com/company/securitas-turkiye/",
  instagram: "https://www.instagram.com/securitasturkiye/",
  nfpa: "https://www.nfpa.org/",
} as const;
